import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Maintenance } from '../../entities/maintenance.model';

@Component({
  selector: 'app-maintenance-modal',
  templateUrl: './maintenance-modal.component.html',
  styleUrls: ['maintenance-modal.component.scss']
})
export class MaintenanceModalComponent implements OnInit {

  @Input() maintenance: Maintenance;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/maintenance-modal/maintenance-modal.component.ts